import CurrencySymbol from './CurrencySymbol';

export default CurrencySymbol;
export {
	CurrencySymbol
};
